import { Cell } from 'react-table';
import { MembersTableItem } from './interfaces';
import { Tags } from './Tags';

export default function InteractionTags({ row: { original: data } }: Cell<MembersTableItem>) {
  return (<Tags tags={data.tags} maxTags={1} />);
}

export { InteractionTags };